import {
  MaxWidthContent,
  PasswordCriterias,
  UnconnectedPageTemplate,
  Form,
  InputPassword,
  useFormConfig,
  Button,
  FormAction,
  FormBloc,
  FormField,
  FormGrid,
  FormRow,
  FormTitle,
  displayErrorToast,
} from "@endya-conformite/ui-kit";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import { zod } from "@endya-conformite/ui-kit/src/lya/exports";
import { Header } from "@src/components/Header/Header";
import { GatewayAuthApi } from "@src/data/auth/auth.api";
import { handleGatewayError } from "@src/data/utils/handleGatewayError";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { passwordWithConfirmationSchema } from "../password.definition";
import styles from "./Login.module.scss";

const schema = passwordWithConfirmationSchema;
export type UpdatePasswordFormValues = zod.infer<typeof schema>;
export function NewPassword() {
  const [query] = useSearchParams();
  const urlRedirect = query.get("url");
  const session = query.get("session");
  const { userId } = useParams<{ userId: string }>();
  const formConfig = useFormConfig<typeof schema, UpdatePasswordFormValues>({
    schema,
  });
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (submittedData: UpdatePasswordFormValues) => {
    setIsSubmitting(true);
    try {
      await GatewayAuthApi.confirmPassword({
        userId: userId ?? "",
        session: session ?? "",
        password: submittedData.password,
      });

      navigate(urlRedirect ?? "/", { replace: true });
    } catch (err) {
      handleGatewayError({
        onResponse: (error) => {
          displayErrorToast(
            error.response.data.message ||
              "Une erreur est survenue lors du changement de mot de passe. Veuillez réessayer."
          );
        },
        onUnhandled: () => {
          displayErrorToast(
            "Impossible de contacter le serveur. Veuillez vérifier votre connexion internet et réessayer."
          );
        },
      })(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const passwordValue = formConfig.watch("password");

  return (
    <UnconnectedPageTemplate>
      <Header />
      <MaxWidthContent>
        <Form formConfig={formConfig} onSubmit={onSubmit}>
          <FormGrid disableHorizontalGutter>
            <FormTitle>
              <h1>Définissez votre nouveau mot de passe</h1>
            </FormTitle>
            <FormRow>
              <FormField>
                <InputPassword<UpdatePasswordFormValues>
                  name="password"
                  label="Nouveau mot de passe"
                  required
                />
              </FormField>
            </FormRow>

            <FormBloc>
              <PasswordCriterias password={passwordValue} />
            </FormBloc>

            <FormRow>
              <FormField>
                <InputPassword<UpdatePasswordFormValues>
                  name="confirm"
                  label="Confirmer le nouveau mot de passe"
                  required
                />
              </FormField>
            </FormRow>
            <FormAction className={styles.buttons}>
              <Button
                type="submit"
                disabled={isSubmitting}
                icon={isSubmitting ? <Loader /> : undefined}
              >
                Changer de mot de passe
              </Button>
            </FormAction>
          </FormGrid>
        </Form>
      </MaxWidthContent>
    </UnconnectedPageTemplate>
  );
}
